// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__Pp9ji","animloader":"loading_animloader__haSne","content":"loading_content__GjiHv"};